import { render, staticRenderFns } from "./AdmissionsMovieTagYear.vue?vue&type=template&id=32146687"
import script from "./AdmissionsMovieTagYear.vue?vue&type=script&lang=js"
export * from "./AdmissionsMovieTagYear.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pforret/Code/Movix/laravel/showtimes.movix/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32146687')) {
      api.createRecord('32146687', component.options)
    } else {
      api.reload('32146687', component.options)
    }
    module.hot.accept("./AdmissionsMovieTagYear.vue?vue&type=template&id=32146687", function () {
      api.rerender('32146687', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/Admissions/AdmissionsMovieTagYear.vue"
export default component.exports